<template>
  <message-for-feed :pending-moderation="pendingModeration">
    <slot name="headnote" />

    <div class="existing-message">
      <div class="author-info d-none d-md-block me-2">
        <div class="profile-image-container">
          <profile-image class="profile-image" :user="author" size="lg" />
        </div>
        <span class="text-primary d-block">
          {{ author.name }}
        </span>
        <span class="sent-at-time d-block">
          {{ timeAgo(sentAt) }}
        </span>
      </div>
      <message-block :id="id" :thread-id="threadId" :can-be-edited="canBeEdited" :editing="editing" :content="content"
                     :is-flagged-by-user="isFlaggedByUser" :flags-count="flagsCount" flag-action-name="flagOriginalMessage"
                     :validation-errors="validationErrors.forumMessage" :update-in-progress="updateInProgress"
                     :can-submit-update="!!editedTitle"
                     @cancel-edit="cancelEdit" @delete="deleteOriginalMessage" @edit="editMessage" @update-message="sendUpdateMessage">
        <template #header-content>
          <div class="d-block d-md-none mb-3">
            <span class="text-primary">
              {{ author.name }}
            </span>
            <span class="sent-at-time">
              {{ timeAgo(sentAt) }}
            </span>
          </div>
          <div class="title">
            <text-input v-if="editing" input-id="title" :label="i18n.t('member.forums.thread_title')" :value="editedTitle"
                        :validation-errors="validationErrors.thread.title"
                        @changed="(value) => editedTitle = value" />
            <template v-else>
              {{ title }}
              <span v-if="edited" class="small-text">{{ i18n.t('member.forums.message_edited') }}</span>
            </template>
          </div>
        </template>
      </message-block>
    </div>
  </message-for-feed>
</template>

<script>
import { mapActions } from 'vuex'
import MessageBlock from './message-block'
import MessageForFeed from './message-for-feed'
import MessageMixin from './message-mixin'
import ProfileImage from '../components/members/profile-image'
import TextInput from '@/components/inputs/text-input'

export default {
  components: {
    MessageBlock,
    MessageForFeed,
    ProfileImage,
    TextInput
  },

  mixins: [ MessageMixin ],

  props: {
    title: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      editedTitle: this.title,
      validationErrors: { forumMessage: {}, thread: {} }
    }
  },

  computed: {
    restoreButtonTitle() {
      return this.i18n.t('member.forums.restore_post', {content: this.title})
    }
  },
  methods: {
    ...mapActions(['deleteOriginalMessage', 'updateThread']),

    cancelEdit() {
      this.editing = false
      this.editedTitle = this.title
    },

    sendUpdateMessage(newContent) {
      this.updateInProgress = true
      this.updateThread({threadId: this.threadId, messageId: this.id, title: this.editedTitle, content: newContent})
        .then(() => {
          this.editing = false
        })
        .catch(({ info }) => {
          this.validationErrors = info.errors
        })
        .finally(() => {
          this.updateInProgress = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
  @use "~common_styles/breakpoints" as breakpoints;
  @use "~friendship_styles/colors" as colors;

  .existing-message {
    display: flex;
  }

  .profile-image-container {
    display: flex;
  }

  .sent-at-time {
    font-size: 11px;
  }

  .author-info {
    flex-basis: 100px;
    flex-grow: 1;

    display: flex;
    flex-direction: column;

    overflow: hidden;
    overflow-wrap: break-word;
  }

  ::v-deep(.message-content) {
    flex: 1 0;
  }

  .title {
    flex: 1 1;
    color: colors.$dark-gray-text-color;
    overflow: hidden;
    overflow-wrap: break-word;
  }

  @include breakpoints.screen-mobile-only {
    .existing-message {
      flex-direction: column;
    }

    .title {
      order: 99; // Move to end to have its own row
      flex-basis: 100%;
    }
  }
</style>
